import type {
  Changelog,
  ChangelogTranslation,
  Language,
} from '@/types/directus'
import type { Locale } from '@/i18n/config'

interface TranslationOptions {
  fallbackToAny?: boolean
}

function normalizeLangCode(
  code: string | Language | null | undefined,
): string | null {
  if (!code) return null
  if (typeof code === 'string') return code.toLowerCase()
  if (typeof code === 'object' && 'code' in code && code.code) {
    return code.code.toLowerCase()
  }
  return null
}

export function findChangelogTranslation(
  changelog: Changelog,
  lang: Locale | string,
  options: TranslationOptions = {},
): ChangelogTranslation | null {
  const translations = changelog.translations as
    | ChangelogTranslation[]
    | undefined

  if (!translations || translations.length === 0) {
    return null
  }

  const normalizedTarget = (lang || '').toLowerCase()
  const exact = translations.find(
    (translation) =>
      normalizeLangCode(translation.languages_code) === normalizedTarget &&
      translation.enable !== false,
  )

  if (exact) return exact

  if (options.fallbackToAny) {
    const fallback = translations.find((translation) => translation.enable)
    if (fallback) return fallback
  }

  return null
}

export function hasTranslationForLocale(
  changelog: Changelog,
  lang: Locale | string,
): boolean {
  return !!findChangelogTranslation(changelog, lang, { fallbackToAny: false })
}
